import { Component, OnInit } from '@angular/core';
import { AuthType } from '@ext-interfaces/authenticator.model';
import { environment } from '../../environments/environment';
import { AuthService } from '../modules/authentication/auth.service';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {
    public extension = environment.extension === 'chrome' ? 'Google' : 'Microsoft';
    public isAuthenticating = false;

    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.isAuthenticating = this.authService.isAuthenticating;
    }

    public authenticateMS(authType: AuthType) {
        this.isAuthenticating = true;
        this.authService.authenicateMicrosoftUser(authType);
    }

    public authenticateGoogle() {
        this.isAuthenticating = true;
        this.authService.authenicateGoogleUser();
    }
}
